// Home.jsx
import Navbar from '../components/Navbar';
import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { apiFetch } from '../services/api';
import BottomNav from '../components/BottomNav';
import Historial from './Historial';
import NewPackage from './NewPackage';
import NewTravel from './NewTravel';
import MyPackages from './MyPackages';
import PackageDetail from './PackageDetail';
import Search from './Search';
import DriverPanel from './DriverPanel';
import MyProfile from './MyProfile';
import Notifications from './Notifications';
import ReportThread from './ReportThread';

export default function Home() {
  const { user, token } = useAuth();
  const [screen, setScreen] = useState('home');
  const [activeTab, setActiveTab] = useState('home');
  const [unread, setUnread] = useState(0);
  const [openPackageId, setOpenPackageId] = useState(null);
  const [openChatDirecto, setOpenChatDirecto] = useState(false);
  const [openReportId, setOpenReportId] = useState(null);

  const handleOpenPackage = (packageId, chat = false) => {
  setOpenPackageId(packageId);
  setOpenChatDirecto(chat);
  setScreen('packageDetail');
  setActiveTab('activity');
};

  const handleOpenReport = (reportId) => {
    setOpenReportId(reportId);
    setScreen('reportThread');
  };

  useEffect(() => {
    const fetchUnread = () => {
      if (token) {
        apiFetch('/notifications', {}, token)
          .then(data => setUnread(data.filter(n => !n.leido).length))
          .catch(() => {});
      }
    };
    fetchUnread();
    const interval = setInterval(fetchUnread, 15000);
    return () => clearInterval(interval);
  }, [token]);

  const goHome = () => { setScreen('home'); setActiveTab('home'); };

  const handleTabChange = (tab) => {
    setOpenPackageId(null);
    setOpenChatDirecto(false);
    setActiveTab(tab);
    if (tab === 'search') setScreen('search');
    else if (tab === 'activity') setScreen('myPackages');
    else if (tab === 'notifications') { setScreen('notifications'); }
    else if (tab === 'profile') setScreen('myProfile');
    else if (tab === 'historial') setScreen('historial');
    else setScreen('home');
  };

  if (openPackageId && screen === 'myPackages') return <MyPackages onBack={() => { setOpenPackageId(null); setOpenChatDirecto(false); goHome(); }} onTabChange={handleTabChange} openPackageId={openPackageId} onClearPackage={() => setOpenPackageId(null)} openChatDirecto={openChatDirecto} onOpenPackage={handleOpenPackage} />;
  if (screen === 'myProfile') return <MyProfile onBack={goHome} onTabChange={handleTabChange} />;
  if (screen === 'newPackage') return <NewPackage onBack={() => setScreen('home')} onTabChange={handleTabChange} onOpenPackage={handleOpenPackage} />;
  if (screen === 'newTravel') return <NewTravel onBack={() => setScreen('home')} onTabChange={handleTabChange} onOpenPackage={handleOpenPackage} />;
  if (screen === 'myPackages') return <MyPackages onBack={goHome} onTabChange={handleTabChange} openPackageId={openPackageId} onClearPackage={() => setOpenPackageId(null)} openChatDirecto={openChatDirecto} onOpenPackage={handleOpenPackage} />;
  if (screen === 'search') return <Search onBack={goHome} onTabChange={handleTabChange} onOpenPackage={handleOpenPackage} />;
  if (screen === 'driverPanel') return <DriverPanel onBack={() => setScreen('home')} onTabChange={handleTabChange} onOpenPackage={handleOpenPackage} />;
  if (screen === 'packageDetail' && openPackageId) return <PackageDetail packageId={openPackageId} onBack={() => { setOpenPackageId(null); setOpenChatDirecto(false); setScreen('home'); }} onTabChange={handleTabChange} openChatDirecto={openChatDirecto} onOpenPackage={handleOpenPackage} />;
  if (screen === 'notifications') return <Notifications onBack={goHome} onTabChange={handleTabChange} onOpenPackage={handleOpenPackage} onOpenReport={handleOpenReport} />;
  if (screen === 'reportThread' && openReportId) return <ReportThread reportId={openReportId} onBack={() => { setOpenReportId(null); goHome(); }} />;
  if (screen === 'historial') return <Historial onTabChange={handleTabChange} onOpenPackage={handleOpenPackage} />;

  
  const hora = new Date().getHours();
  const saludo = hora < 13 ? 'Buenos días' : hora < 20 ? 'Buenas tardes' : 'Buenas noches';
  const nombre = user?.name?.split(' ')[0] || '';

  const actions = [
    { id: 'newPackage', icon: '📦', title: 'Publicar envío', desc: 'Publica y encuentra conductor', accent: '#f97316' },
    { id: 'driverPanel', icon: '📋', title: 'Ver recogidas disponibles', desc: 'Paquetes disponibles cerca', accent: '#3b82f6' },
    { id: 'newTravel', icon: '🚗', title: 'Publicar viaje', desc: 'Gana llevando envíos', accent: '#22c55e' },
    { id: 'myPackages', icon: '⚡', title: 'Mi actividad', desc: 'Envíos y viajes activos', accent: '#a855f7' },
  ];

  return (
    <div className="min-h-screen pb-24" style={{ backgroundColor: '#0d0f14' }}>
      <Navbar onOpenPackage={handleOpenPackage} />

      {/* Fondo radial decorativo */}
      <div style={{
        position: 'fixed', top: 0, left: 0, right: 0, height: '300px',
        background: 'radial-gradient(ellipse 80% 50% at 50% -5%, #f9731615 0%, transparent 70%)',
        pointerEvents: 'none', zIndex: 0,
      }} />

      <div className="max-w-lg mx-auto px-4 pt-5 relative" style={{ zIndex: 1 }}>

        {/* Saludo */}
        <div style={{ marginBottom: '20px' }}>
          <p style={{ color: '#6b7280', fontSize: '13px', marginBottom: '4px' }}>
            {saludo}, <span style={{ color: '#f97316', fontWeight: '600' }}>{nombre}</span> 👋
          </p>
          <h1 style={{ color: 'white', fontWeight: '800', fontSize: '24px', lineHeight: '1.2', letterSpacing: '-0.02em' }}>
            ¿Qué necesitas hoy?
          </h1>
        </div>

        {/* Banner */}
        <div style={{
          borderRadius: '20px', overflow: 'hidden', marginBottom: '24px', position: 'relative',
          background: 'linear-gradient(135deg, #ea580c 0%, #f97316 50%, #fb923c 100%)',
          boxShadow: '0 16px 48px #f9731628',
        }}>
          {/* Círculos decorativos */}
          <div style={{
            position: 'absolute', top: '-30px', right: '-30px',
            width: '130px', height: '130px', borderRadius: '50%',
            backgroundColor: 'rgba(255,255,255,0.07)',
          }} />
          <div style={{
            position: 'absolute', bottom: '-20px', right: '50px',
            width: '70px', height: '70px', borderRadius: '50%',
            backgroundColor: 'rgba(255,255,255,0.05)',
          }} />
          <div style={{
            position: 'absolute', top: '16px', right: '20px',
            fontSize: '44px', opacity: 0.18, transform: 'rotate(12deg)', lineHeight: 1,
          }}>
            🚗
          </div>

          <div style={{ padding: '20px 20px 20px', position: 'relative' }}>
            <div style={{
              display: 'inline-flex', alignItems: 'center', gap: '5px',
              backgroundColor: 'rgba(255,255,255,0.18)', borderRadius: '20px',
              padding: '3px 10px', marginBottom: '10px',
            }}>
              <div style={{ width: '5px', height: '5px', borderRadius: '50%', backgroundColor: 'white' }} />
              <p style={{ color: 'white', fontSize: '10px', fontWeight: '700', letterSpacing: '0.06em', textTransform: 'uppercase' }}>
                Comunidad SenDViGo
              </p>
            </div>

            <h2 style={{ color: 'white', fontWeight: '800', fontSize: '20px', lineHeight: '1.25', letterSpacing: '-0.01em', marginBottom: '6px' }}>
              Juntos llegamos más lejos
            </h2>

            <p style={{ color: 'rgba(255,255,255,0.85)', fontSize: '13px', fontWeight: '500', marginBottom: '4px', lineHeight: '1.4' }}>
              Haz que cada kilometro cuente.
            </p>
            <p style={{ color: 'rgba(255,255,255,0.65)', fontSize: '12px', lineHeight: '1.5' }}>
              Compartir viaje es nuestra manera de reciclar.
            </p>
          </div>
        </div>

        {/* Acciones */}
        <p style={{ color: '#3a3d45', fontSize: '10px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: '12px' }}>
           Acciones rápidas 
        </p>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
          {actions.map(action => (
            <button
              key={action.id}
              onClick={() => setScreen(action.id)}
              style={{
                backgroundColor: '#1a1d24',
                border: `1px solid ${action.accent}22`,
                borderRadius: '18px', padding: '18px 16px', textAlign: 'left',
                cursor: 'pointer', transition: 'transform 0.15s',
              }}
              onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.02)'}
              onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
            >
              <div style={{
                width: '40px', height: '40px', borderRadius: '12px', marginBottom: '12px',
                backgroundColor: `${action.accent}18`,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: '20px',
              }}>
                {action.icon}
              </div>
              <p style={{ color: 'white', fontWeight: '700', fontSize: '13px', marginBottom: '4px' }}>
                {action.title}
              </p>
              <p style={{ color: '#4b5563', fontSize: '11px', lineHeight: '1.4' }}>
                {action.desc}
              </p>
            </button>
          ))}
        </div>

        {/* Tagline */}
        <div style={{ textAlign: 'center', paddingTop: '20px', paddingBottom: '4px' }}>
          <p style={{ color: '#2a2d35', fontSize: '11px' }}>
            SenDViGo · La red de favores entre personas 🤝
          </p>
        </div>

      </div>

      <BottomNav active={activeTab} onChange={handleTabChange} unreadCount={unread} />
    </div>
  );
}